import React from "react";

// Custom Clapping Hands Icon - two hands meeting with motion lines
export const ClapIcon = ({ className = "h-4 w-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M2 12 L5 8 L6 8 L6 6 L7 6 L7 5 L8 5 L8 4 L9 4 L9 6 L10 6 L10 11 L10 14 L8 17 L4 17 L2 14 Z" />
    <path d="M22 12 L19 8 L18 8 L18 6 L17 6 L17 5 L16 5 L16 4 L15 4 L15 6 L14 6 L14 11 L14 14 L16 17 L20 17 L22 14 Z" />
    <line x1="10" y1="2" x2="11" y2="3" stroke="currentColor" strokeWidth="1.5" />
    <line x1="12" y1="1" x2="12" y2="3" stroke="currentColor" strokeWidth="1.5" />
    <line x1="14" y1="2" x2="13" y2="3" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
